import { useState } from "react";
import { axiosAuthedInstance } from "../../utils/axiosApi";
import { BaseContainer } from "../../components/container";
import { Button } from "../../components/button";
import { HeaderTitle } from "../../components/page_sections";

const TestSchemaViolation = (props) => {
    const [result, setResult] = useState(null);
    const [responseResult, setResponseResult] = useState(null);

    const sendInvalid = async () => {
        setResult(null);
        try {
            const resp = await axiosAuthedInstance.post('/user/account-settings/', {
                eligibility_notifications_enabled: 'yes_please', // must be boolean
                ruleset_group: 42,                               // must be string
            });
            setResult({ status: resp.status, body: resp.data });
        } catch (err) {
            if (err.response) {
                setResult({ status: err.response.status, body: err.response.data });
            } else {
                setResult({ status: 0, body: { error: err.message } });
            }
        }
    };

    const triggerInvalidResponse = async () => {
        setResponseResult(null);
        try {
            const resp = await axiosAuthedInstance.get('/test-response-violation/?raise_error=true');
            setResponseResult({ status: resp.status, body: resp.data });
        } catch (err) {
            if (err.response) {
                setResponseResult({ status: err.response.status, body: err.response.data });
            } else {
                setResponseResult({ status: 0, body: { error: err.message } });
            }
        }
    };

    return (
        <BaseContainer {...props}>
            <HeaderTitle>Schema Violation Test</HeaderTitle>
            <Button onClick={sendInvalid}>
                Send Invalid Account Settings
            </Button>
            {result && (
                <div>
                    <p>Response status: {result.status}</p>
                    <pre>{JSON.stringify(result.body, null, 2)}</pre>
                </div>
            )}
            <Button onClick={triggerInvalidResponse}>
                Trigger Invalid Response
            </Button>
            {responseResult && (
                <div>
                    <p>Response violation status: {responseResult.status}</p>
                    <pre>{JSON.stringify(responseResult.body, null, 2)}</pre>
                </div>
            )}
        </BaseContainer>
    );
};

export default TestSchemaViolation;
